module.exports = __webpack_public_path__ + "img/f59.c3b54239.png";